import { useMemo } from "react";

import useGetFartherManagedAccounts from "@fartherfinance/frontend/api/Accounts/hooks/useGetFartherManagedAccounts";
import { FartherManagedAccount } from "@fartherfinance/frontend/api/Accounts/Types";
import { ClientId, FartherAccountId } from "@fartherfinance/frontend/api/Types";

import { useAdvisorPageInit } from "@src/multiCustodian/hooks/Advisor/useAdvisorPageInit";

export function useFartherManagedClientAccount(
  clientId: ClientId,
  accountId: FartherAccountId | null | undefined
): {
  account: FartherManagedAccount | null | undefined;
  accountDisplayName: string;
  accountsError: boolean;
  accountsLoading: boolean;
} {
  const { requestAuth } = useAdvisorPageInit();

  const accounts = useGetFartherManagedAccounts(clientId, requestAuth);
  const account: FartherManagedAccount | null | undefined = useMemo(() => {
    if (accounts.data === undefined) {
      return null;
    }

    const targetAccount = accounts.data.find(
      (acc) => acc.virtualAccountId === accountId
    );

    return targetAccount;
  }, [accounts.data, accountId]);

  const accountDisplayName = useMemo(
    () =>
      account && account.accountDetails
        ? `${account.accountDetails.custodian} - ${
            account.accountDetails.displayName
          } (${account.accountDetails.custodianAccountNumber ?? ""})`
        : "",
    [account]
  );
  return {
    account,
    accountDisplayName,
    accountsError: accounts.hasError,
    accountsLoading: accounts.isLoading,
  };
}
